import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

export type SkeletonProps = ComponentProps<'div'>;

const Skeleton = ({ className, ...props }: SkeletonProps) => {
  return (
    <div
      data-slot="skeleton"
      className={cn('animate-pulse rounded-md bg-gray-200', className)}
      {...props}
    />
  );
};

export default Skeleton;
